import React, { useEffect, useState } from 'react';
import GalaxyBackground from './GalaxyBackground'

const HeroSection = () => {
    return (
        <GalaxyBackground />
    );
};

export default HeroSection;
